import { useState } from 'react';

export const useEventFilters = () => {
  const [searchInput, setSearchInput] = useState('');
  const [categories, setCategories] = useState(new Set());
  const [dateRange, setDateRangeState] = useState('');
  const [customDate, setCustomDateState] = useState({
    startDate: null,
    endDate: null,
  });
  const [timeOfDay, setTimeOfDay] = useState(new Set());

  const toggleCategory = (category) => {
    setCategories((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(category)) {
        newSet.delete(category);
      } else {
        newSet.add(category);
      }
      return newSet;
    });
  };

  const updateDateRange = (range) => {
    setDateRangeState(range);
    if (range !== 'custom') {
      setCustomDateState({ startDate: null, endDate: null });
    }
  };

  const updateCustomDate = ({ startDate, endDate }) => {
    setDateRangeState('custom');
    setCustomDateState({ startDate, endDate });
  };

  const toggleTimeOfDay = (time) => {
    setTimeOfDay((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(time)) {
        newSet.delete(time);
      } else {
        newSet.add(time);
      }
      return newSet;
    });
  };

  const resetFilters = () => {
    setSearchInput('');
    setCategories(new Set());
    setDateRangeState('');
    setCustomDateState({ startDate: null, endDate: null });
    setTimeOfDay(new Set());
  };

  return {
    searchInput,
    setSearchInput,
    filters: { categories, dateRange, customDate, timeOfDay },
    toggleCategory,
    updateDateRange,
    updateCustomDate,
    toggleTimeOfDay,
    resetFilters,
  };
};
